<template>
  <div id="app">
    <NavMenu />
    <!-- 添加 router-view -->
      <router-view></router-view>
      <Foot></Foot>
  </div>
</template>

<script>
import NavMenu from './components/NavMenu.vue';
import Foot from './components/fot.vue'
import { post } from './utils/http';
export default {
  name: 'App',
  components: {
    NavMenu,Foot
  },
  mounted() {
    post('index/getCompanyInfo').then(res => {
      if(res.code==1){
        console.log('公司数据',res.data)
        localStorage.setItem('companyInfo',JSON.stringify(res.data))
      }
    })
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.Appcontent {
  width: 1200px;
  margin: 0 auto;
}
</style>